import React, { useEffect, useState, ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import CheckBox from '../../Components/CheckBox/CheckBox'
import { FiEdit } from 'react-icons/fi'
import { MdOutlineSaveAlt } from 'react-icons/md'
import http from '../../Service/http'
import { toast } from 'react-toastify'
import { accept, OknoPropListType } from '../../store/accept'
import { getAcceprProperties } from '../../Service/accept'
import ConfirmModal from './../../Components/Modal/ConfirmModal'
import { FcCancel } from 'react-icons/fc'

export const AcceptRightContainer = observer(function ({ ts }: { ts: number }) {
	const { t } = useTranslation()
	const notify = (title: string) => toast(title)
	const [form, setForm] = useState<OknoPropListType>({
		id_okno_properties: 11,
		okno_title: 'Материальный бухгалтер',
		okno_pole: 't_fio_pole2',
		Description: '',
		visibility: true,
		sotrudnik: true
	})

	const [delModal, setDelModal] = useState<{
		modal: boolean
		id_docs: number
	}>({
		modal: false,
		id_docs: 0
	})

	const [disbles, setDsbles] = useState<number>(0)

	const getAllTeachers = async () => {
		const data = await getAcceprProperties(ts)
		accept.newOknoPropList(data)
	}

	useEffect(() => {
		getAllTeachers()
	}, [ts])

	return (
		<>
			<ConfirmModal
				setIsOpen={() => {
					setDelModal({
						modal: false,
						id_docs: 0
					})
				}}
				title={t('st:button.del')}
				isOpen={delModal.modal}
				hundleTrue={async () => {
					if (delModal.id_docs) {
						const res = await http.delete('/okno/customer?id=' + delModal.id_docs)
						if (res.data.result) {
							getAllTeachers()
							notify(t('st:other.saved'))
							setDelModal({
								modal: false,
								id_docs: 0
							})
						}
					}
				}}
			/>
			<div className='TableWrapper'>
				<table className='accept_table'>
					<thead>
						<tr>
							<th style={{ width: '5%' }}>№</th>
							<th style={{ width: '35%' }}>{t('st:accept.titles.name')} </th>
							<th style={{ width: '20%' }}>{t('st:accept.titles.pole')}</th>
							<th style={{ width: '35%' }}>{t('st:accept.titles.desc')}</th>
							<th style={{ width: '35%' }}>{t('st:accept.titles.visibility')}</th>
							<th style={{ width: '5%' }}>{t('st:accept.titles.edit')}</th>
						</tr>
					</thead>
					<tbody>
						{accept.oknoPropList.map((item: any, index: number) => {
							let dsbl = true
							if (disbles == item.id_okno_properties) {
								return (
									<tr key={index} style={{ backgroundColor: 'rgb(160 202 223)', height: dsbl ? '' : '52' }}>
										<td>{index + 1}</td>
										<td>{form.okno_title}</td>
										<td>{form.okno_pole}</td>
										<td>
											<textarea
												className='accept_textarea'
												name=''
												value={form.Description}
												id=''
												onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
													setForm(state => {
														return { ...state, Description: e.target.value }
													})
												}}
												rows={3}
											></textarea>
										</td>
										<td>
											<CheckBox
												onchange={(e: any) => {
													setForm((state: any) => {
														return { ...state, visibility: e }
													})
												}}
												checked={form.visibility}
												active={true}
												dsbl={false}
												item={item}
												styles={{ width: '16px', margin: '0 auto' }}
											/>
										</td>
										<td>
											<div className='edit'>
												<MdOutlineSaveAlt
													title={t('st:button.save')}
													onClick={async () => {
														const res = await http.put('/okno/accept/proporties', form)
														if (res.data.result) {
															getAllTeachers()
															notify(t('st:other.saved'))
															setDsbles(0)
														}
													}}
												/>
												<FcCancel
													onClick={() => {
														setDsbles(0)
													}}
												/>
											</div>
										</td>
									</tr>
								)
							}
							return (
								<tr
									key={index}
									style={{ backgroundColor: dsbl ? '' : 'rgb(160 202 223)', height: dsbl ? '' : '52' }}
									onClick={() => {
										setDsbles(0)
									}}
								>
									<td>{index + 1}</td>
									<td>{item.okno_title}</td>
									<td>{item.okno_pole}</td>
									<td>{item.Description}</td>
									<td>
										<CheckBox
											styles={{ width: '16px', margin: '0 auto' }}
											onchange={() => {}}
											checked={item.visibility}
											active={true}
											dsbl={dsbl}
											item={item}
										/>
									</td>
									<td>
										<div className='edit' style={{ justifyContent: 'center' }}>
											<FiEdit
												onClick={(e: any) => {
													e.stopPropagation()
													setDsbles(item.id_okno_properties)
													setForm(item)
												}}
											/>
										</div>
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		</>
	)
})
